import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Routes } from '@angular/router';
import { Observable } from 'rxjs';
import { INotificationPreference, NotificationPreference } from '../../shared/model/notification-preference-my-suffix.model';
import { UserRouteAccessService } from './../../core/auth/user-route-access-service';
import { NotificationPreferenceMySuffixDetailComponent } from './notification-preference-my-suffix-detail.component';
import { NotificationPreferenceComponent } from './notification-preference-my-suffix-update.component';
import { NotificationPreferenceService } from './notification-preference.service';


@Injectable({ providedIn: 'root' })
export class NotificationPreferenceServiceResolve implements Resolve<any> {
    constructor(private service: NotificationPreferenceService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.params['id'] ? route.params['id'] : null;
        if (id) {
            return this.service.find(id).map((manualRequest: HttpResponse<INotificationPreference>) => manualRequest.body);
        }
        return Observable.of(new NotificationPreference());
    }
}

export const notificationPreferenceRoute: Routes = [
    //NotificationPreferenceMySuffixDetailComponent
    {
        path: 'notification-preference/:id',
        component: NotificationPreferenceComponent,
        resolve: {
            notificationPreferenceDetail: NotificationPreferenceServiceResolve
        },
        data: {
            authorities: [
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'AUDIT_USER_STAFF',
                'AUDIT_USER',
                'CLIENT',
                'CLIENT_STAFF',
                'ADMIN_STAFF'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'notification-preference'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'notification-preference-detail',
        component: NotificationPreferenceMySuffixDetailComponent,
        resolve: {
            notificationPreferenceDetail: NotificationPreferenceServiceResolve
        },
        data: {
            authorities: [
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'AUDIT_USER_STAFF',
                'AUDIT_USER',
                'CLIENT',
                'CLIENT_STAFF'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'notification-preference-detail'
        },
        canActivate: [UserRouteAccessService]
    }
];
